export const wp_assoc: { [service_id: number]: string } = (
  document.getElementById("wp_assoc") as HTMLInputElement
)?.value
  ? JSON.parse((document.getElementById("wp_assoc") as HTMLInputElement).value)
  : "";
export const wp_categories = (
  document.getElementById("wp_categories") as HTMLInputElement
)?.value?.split(",");
export const wp_provider = Number(
  (document.getElementById("wp_provider") as HTMLInputElement)?.value
);
export const wp_center = Number(
  (document.getElementById("wp_center") as HTMLInputElement)?.value
);
